import "./styles.scss";
import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	FormGroup,
	Row,
	Card,
	CardImg,
	CardBody,
	CardText,
	Badge,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Breadcrumb,
	BreadcrumbItem,
} from "reactstrap";
import "assets/scss/website/app.scss";
import InterestImage from "assets/images/interests.png";
import DateImage from "assets/images/date.png";
import ProfileImage from "assets/images/profile_icon.png";
import classnames from "classnames";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import Informations from "./Informations";
import ManageAppointment from "./Appointments";
import MayInterests from "./Interests";
import MyDeals from "./Deals";
import MyLists from "./Lists";
import ProfileService from "services/Website/ProfileService";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import http from "services/HttpService";

const Profile = (props) => {
	const AuthData = useSelector((state) => state.Auth);
	const interests = props.match.params.interests;
	const { t } = useTranslation();
	const profileService = new ProfileService();
	const [profileData, setProfileData] = useState({
		email: "",
		first_name: "",
		last_name: "",
		phone: "",
		current_password: "",
		password: "",
		password_confirmation: "",
	});
	const [activeTab, setActiveTab] = useState("1");
	const toggleVertical = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};

	useEffect(() => {
		http.setLang();
		profileService.getProfile().then((response) => {
			if (response && response.status === SuccessOk) {
				setProfileData({ ...response.data });
			}
		});
	}, []);

	// const deleteResaleHandler = (id) => {
	//     const updatedResales = profileData.resales.filter(item => item.id !== id)
	//     setProfileData({
	//         ...profileData,
	//         resales: [...updatedResales]
	//     })
	// }
	useEffect(() => {
		if (interests === "interests") {
			toggleVertical("3");
		}
	}, []);
	return (
		<div className="websitPages profile">
			<MetaTags>
				<title>{t("Profile Page")}</title>
			</MetaTags>
			<div className="pt-10rem">
				<Container fluid className="px-lg-5 pb-5 pt-4">
					{/* <ol className="breadcrumb ps-0 mb-2">
						<BreadcrumbItem>
							<Link to="/">{t("home")}</Link>
						</BreadcrumbItem>
						<BreadcrumbItem active>{t("My Profile")}</BreadcrumbItem>
					</ol> */}
					<h4
						className="page-title"
						dangerouslySetInnerHTML={{
							__html: t("My Profile"),
						}}></h4>
					<Row className="pt-2 mt-3">
						<Col lg={3} md={4}>
							<div className="px-2 pb-5">
								<Nav pills className="flex-column left-side">
									<NavItem>
										<NavLink
											style={{ cursor: "pointer" }}
											className={classnames({ active: activeTab === "1" })}
											onClick={() => {
												toggleVertical("1");
											}}>
											{/* <img className="pe-2" src={ProfileImage} />{" "} */}
											{t("Basic Info")}
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											style={{ cursor: "pointer" }}
											className={classnames({ active: activeTab === "2" })}
											onClick={() => {
												toggleVertical("2");
											}}>
											{/* <img className="pe-2" src={DateImage} />{" "} */}
											{t("Manage Appointments")}
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											style={{ cursor: "pointer" }}
											className={classnames({ active: activeTab === "3" })}
											onClick={() => {
												toggleVertical("3");
											}}>
											{/* <img className="pe-2" src={InterestImage} /> */}
											{t("My Intrests")}
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											style={{ cursor: "pointer" }}
											className={classnames({ active: activeTab === "4" })}
											onClick={() => {
												toggleVertical("4");
											}}>
											{/* <img className="pe-2" src={InterestImage} />{" "} */}
											{t("My Lists")}
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											style={{ cursor: "pointer", margin: "0" }}
											className={classnames({ active: activeTab === "5" })}
											onClick={() => {
												toggleVertical("5");
											}}>
											{/* <img className="pe-2" src={InterestImage} />{" "} */}
											{t("my deals")}
										</NavLink>
									</NavItem>
								</Nav>
							</div>
						</Col>
						<Col lg={9} md={8}>
							<TabContent activeTab={activeTab} className="text-muted">
								<TabPane tabId="1">
									<Row>
										<Col sm="12">
											<Informations profile={profileData} />
										</Col>
									</Row>
								</TabPane>
								<TabPane tabId="2">
									<Row>
										<Col sm="12">
											{activeTab === "2" ? (
												<ManageAppointment history={props.history} />
											) : null}
										</Col>
									</Row>
								</TabPane>
								<TabPane tabId="3">
									<Row>
										<Col sm="12">
											{activeTab === "3" ? (
												<MayInterests history={props.history} />
											) : null}
										</Col>
									</Row>
								</TabPane>
								<TabPane tabId="4">
									<Row>
										<Col sm="12">
											{activeTab === "4" ? (
												<MyLists history={props.history} />
											) : null}
										</Col>
									</Row>
								</TabPane>
								<TabPane tabId="5">
									<Row>
										<Col sm="12">
											{activeTab === "5" ? (
												<MyDeals
													history={props.history}
													setProfileData={setProfileData}
												/>
											) : null}
										</Col>
									</Row>
								</TabPane>
							</TabContent>
						</Col>
					</Row>
				</Container>
			</div>
		</div>
	);
};

export default Profile;
